<template>
    <div>
      <CRow>
        <CCol md="12">
          <CCard class="mb-3 shadow-sm">
            <CCardBody  v-for="temp in section" :key="temp.id">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">{{ temp.title }}</h5>
                <CButton class="custom-btn-007CEF" size="sm" @click="editArticle(temp)">Edit</CButton>
              </div>
              <hr class="mt-3 mb-0" />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        section: [
          { id: 1, title: "Homepage" },
        ]
      }
    },
    methods: {
      editArticle(section) {
        console.log("Editing:", section.title)
        this.$router.push(section.title);
        // Open modal or navigate to edit page
      }
    }
  }
  </script>
  
  <style scoped>
  .card-title {
    font-weight: 600;
    font-size: 1.1rem;
  }
  hr {
    border: none;
    border-top: 1px solid #e0e0e0;
  }
  </style>